export default {
	name: 'Regions',
	components: {
		'vue-part': require('./Part/index.vue').default
	}
};
